/* src/app/core/pages/redirection/redirection.component.scss */
/*# sourceMappingURL=redirection.component.css.map */
